export default __webpack_public_path__ + "media/images/mailer/icon_flag-fb052043db6f17c4f79c21fccff09700.png";